import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { SortDirection, CursorMode } from './Enums'
/**
* Class SessionsListRequestQuery
*  Query params for operation "SessionsList"
*/
export class SessionsListRequestQuery extends ActiveModel {

/**
  * ['Filter.CreatedBefore']
  * Фильтр по дате создания (не позднее, не включая)<br>
  */
  @ActiveField()
  ['Filter.CreatedBefore']?: string


/**
  * ['Filter.CreatedAfter']
  * Фильтр по дате создания (не раньше, включительно)<br>
  */
  @ActiveField()
  ['Filter.CreatedAfter']?: string


/**
  * ['Filter.ExpireBefore']
  * По дате истечения (не позднее, не включая)<br>
  */
  @ActiveField()
  ['Filter.ExpireBefore']?: string


/**
  * ['Filter.ExpireAfter']
  * По дате истечения (не раньше, включительно)<br>
  */
  @ActiveField()
  ['Filter.ExpireAfter']?: string


  /**
  * ['Filter.HasExpiration']
  * По наличию даты истечения<br>  */
  @ActiveField()
  ['Filter.HasExpiration']?: boolean


  /**
  * ['Filter.IsLongSession']
  * По признаку "продолжительности жизни" сессии<br>  */
  @ActiveField()
  ['Filter.IsLongSession']?: boolean


/**
  * Query
  * Поисковый запрос<br>
  */
  @ActiveField()
  Query?: string


  /**
  * Limit
  * Кол-во элементов в результате. <br><br>Если значение меньше 1, то вернуть все элементы<br>  */
  @ActiveField()
  Limit?: number


/**
  * SortField
  * Поле для сортировки<br>
  */
  @ActiveField()
  SortField?: string


  /**
  * SortDirection
  * Направление сортировки<br>  */
  @ActiveField()
  SortDirection?: SortDirection


  /**
  * CursorMode
  * Режим курсора. Если значение указано, то необходимо<br>указывать Web.Core.Pagination.SortOptions.CursorField и Web.Core.Pagination.SortOptions.CursorId  */
  @ActiveField()
  CursorMode?: CursorMode


/**
  * CursorField
  * Значение Web.Core.Pagination.SortOptions.SortField первого/последнего элемента<br>(в зависимости от курсора Web.Core.Pagination.SortOptions.CursorMode),<br>полученное в рамках ответа на предыдущий курсорный запрос<br>
  */
  @ActiveField()
  CursorField?: string


/**
  * CursorId
  * Значение уникального ключа (чаще всего, но не обязательно, это id) первого/последнего элемента<br>(в зависимости от курсора Web.Core.Pagination.SortOptions.CursorMode),<br>полученное в рамках ответа на предыдущий курсорный запрос<br>
  */
  @ActiveField()
  CursorId?: string
}
